<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="flex items-center mb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pra-Presentasi PJP Baru
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div
              class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
              style="min-height: 60vh"
            >
              <div class="row">
                <div
                  class="col-md-6 d-flex justify-content-start"
                  style="padding-left: 2rem; padding-top: 0.5rem"
                >
                  <img
                    src="../../../assets/images/borneo-indobara-icon.png"
                    alt=""
                    style="width: 15%; height: auto"
                  />
                </div>
                <div
                  class="col-md-6 d-flex justify-content-end"
                  style="padding-right: 2rem; padding-top: 0.5rem"
                >
                  <p class="fs-5 fw-bold" style="">BIB-HSE-PPO-F-096-02</p>
                </div>
              </div>
              <div class="container p-4">
                <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                  SURAT PERMOHONAN PENGESAHAN PJO
                </h1>
                <p
                  class="text-center fs-8 mb-3"
                  style="font-family: 'Inter-Regular'"
                >
                  Formulir ini digunakan untuk membuat permohonan pengesahan
                  calon PJO yang diajukan oleh perusahaan jasa/ mitra kerja di
                  PT Borneo Indobara
                </p>
                <div class="row mb-2">
                  <div class="col-md-3">&nbsp;</div>
                  <div class="col-md-6">
                    <p for="nomor" class="form-label text-center fs-8 fw-bold">
                      Nomor
                    </p>
                    <p class="form-label text-center fs-8">
                      {{ formValues.noSertifikat }}
                    </p>
                  </div>
                  <div class="col-md-3">&nbsp;</div>
                </div>
                <p class="fs-8 mb-2" style="font-family: 'Inter-Regular'">
                  Yang bertanda tangan di bawah ini:
                </p>
                <!-- form di sini -->
                <form action="#">
                  <!-- <div class="row mb-1">
                          <div class="col-md-12">
                              <p class="text-danger fst-italic fs-8 fw-bold">
                                  * Wajib diisi
                              </p>
                          </div>
                      </div> -->
                  <div class="row mb-2">
                    <div class="col-md-6">
                      <label for="nama" class="form-label fs-8 fw-bold"
                        >Nama</label
                      >
                      <p class="form-label fs-8">
                        {{ formValues.namaPemimpin }}
                      </p>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-md-6">
                      <label for="jabatan" class="form-label fs-8 fw-bold"
                        >Jabatan</label
                      >
                      <p class="form-label fs-8">
                        {{ formValues.jabatanPemimpin }}
                      </p>
                    </div>
                  </div>
                  <p class="fs-8 mb-2">
                    Mohon kepada Kepala Teknik Tambang PT Borneo Indobara untuk
                    mengesahkan orang sebagai berikut:
                  </p>
                  <div class="row mb-2">
                    <div class="col-md-6">
                      <label for="nama" class="form-label fs-8 fw-bold"
                        >Nama</label
                      >
                      <p class="form-label fs-8">{{ formValues.nama }}</p>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-md-6">
                      <label for="jabatan" class="form-label fs-8 fw-bold"
                        >Jabatan</label
                      >
                      <p class="form-label fs-8">
                        {{ formValues.jabatan }}
                      </p>
                    </div>
                  </div>
                  <p class="fs-8">
                    Untuk disahkan sebagai
                    <b>Penanggung Jawab Operasional (PJO)</b> di PT/CV
                  </p>
                  <div class="col-md-6">
                    <p class="form-label fs-8 fw-bolder">
                      {{ kontraktor.namaKontraktor }}
                    </p>
                  </div>
                  <p class="fs-8 mt-2">
                    Bersama ini kami lampirkan dokumen pendukung meliputi:
                  </p>
                  <div class="text-xs">
                    <ol type="1" class="list-decimal font-inter ml-7 my-4">
                      <li>
                        Penunjukan PJO oleh pimpinan tertinggi perusahaan jasa
                        pertambangan.
                      </li>
                      <li>Dokumen legalitas perusahaan.</li>
                      <li>
                        Salinan IUJP untuk perusahaan jasa pertambangan inti
                        atau izin yang dikeluarkan oleh instansi terkait untuk
                        perusahaan jasa pertambangan non inti.
                      </li>
                      <li>
                        Struktur organisasi perusahaan yang menggambarkan posisi
                        PJO yang ditandatangani oleh pemimpin tertinggi
                        perusahaan dan diberi cap basah perusahaan.
                      </li>
                      <li>
                        Surat pernyataan bermaterai yang ditandatangani oleh
                        pemimpin tertinggi perusahaan yang disebutkan dalam
                        dokumen perusahaan yang menyatakan mendukung semua
                        program kegiatan calon PJO dalam mengimplementasikan
                        KepMen 1827 K /30/MEM/2018 dan penerapan Sistem
                        Manajemen Keselamatan Penambangan (SMKP).
                      </li>
                      <li>
                        Surat pernyataan komitmen PJO dalam melaksanakan
                        peraturan perundangan-undangan dan Sistem Managemen
                        Keselamatan Pertambangan.
                      </li>
                      <li>
                        Daftar riwayat hidup calon PJO (bukti lampiran
                        sertifikat kompetensi, pengalaman kerja minimal 3 tahun
                        dalam posisi yang sama).
                      </li>
                      <li>
                        Calon PJO wajib memiliki kompetensi minimal POP atau
                        yang diminta khusus KTT berdasarkan pertimbangan KPLH
                        dan IBPR bisnis proses.
                      </li>
                      <li>
                        Salinan pengesahan calon PJO apabila sebelumnya sudah
                        pernah disahkan menjadi PJO.
                      </li>
                      <li>
                        Surat keberadaan domisili bagi calon PJO untuk tinggal
                        di jobsite dan tidak boleh dilakukan secara remote.
                      </li>
                      <li>
                        Surat pernyataan bermaterai tentang kebenaran dokumen
                        yang ditandatangani oleh pemohon.
                      </li>
                    </ol>
                  </div>
                  <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                    Demikian surat permohonan ini kami sampaikan, atas perhatian
                    dan pengesahan yang diberikan kami sampaikan terima kasih.
                  </p>

                  <div class="row mb-3">
                    <div class="col-md-3">
                      <label for="tempat" class="form-label fs-8 fw-bold"
                        >Tempat</label
                      >
                      <p class="form-label fs-8">{{ formValues.tempat }}</p>
                    </div>
                    <div class="col-md-3">
                      <label for="tanggal" class="form-label fs-8 fw-bold"
                        >Tanggal</label
                      >
                      <datepicker
                        v-model="formValues.tanggal"
                        value=""
                        name="tanggal"
                        placeholder="Pilih Tanggal"
                        class="form-control fs-9"
                        input-class="fw-bold"
                        format="yyyy-MM-dd"
                        disabled
                      ></datepicker>
                    </div>
                  </div>

                  <div class="row mb-2">
                    <div class="col-md-6">
                      <label for="tandaTangan" class="form-label fs-8 fw-bold">
                        Tanda Tangan (png, jpg, jpeg)
                      </label>
                      <div v-if="fileTtd != ''" class="fs-8 mb-2">
                        <img :src="fileTtd" style="height: 5rem" />
                      </div>
                      <!-- <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'100%'" :h="'85%'"
                              :disabled="state.disabled" class="example border"></Vue3Signature> -->
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <label for="namaPimpinan" class="form-label fs-8 fw-bold"
                        >Nama Lengkap</label
                      >
                      <p class="form-label fs-8">
                        {{ formValues.namaTTD }}
                      </p>
                      <label
                        for="jabatanTertingi"
                        class="form-label fs-8 fw-bold"
                        >Pimpinan Tertinggi Perusahaan</label
                      >
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- &lt;!&ndash; You can customize the loading content here (e.g., a spinner) &ndash;&gt; -->
    <div>
      <img
        src="../../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
  <!-- modal filter -->
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  ></div>
</template>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../../GlobalDataMixin";
import Datepicker from "vuejs3-datepicker";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import axios from "axios";
import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_SIO_GET_PJOPENGESAHAN,
  CMS_VIEW_IMAGE,
  CMS_GET_KELENGKAPAN_SIO,
} from "@/constants";
//import Swal from "sweetalert2"

const url_get_pjopengesahan = API_BASE_URL + CMS_SIO_GET_PJOPENGESAHAN;
const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;

export default {
  mixins: [GlobalDataMixin],
  name: "Form1View",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
  },
  data() {
    return {
      isLoading: true,
      id: null,
      sioID: null,
      idKelengkapan: null,
      formValues: {
        namaPemimpin: "",
        jabatanPemimpin: "",
        nama: "",
        perusahaan: "",
        jabatan: "",
        kompetensi: "",
        noSertifikat: "",
        pjo: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        namaTTD: "",
        ttd: "",
      },
      kontraktor: [],
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getPJOPengesahan(this.id);
  },
  methods: {
    getPJOPengesahan(idform) {
      axios
        .get(url_get_pjopengesahan + idform, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("getPJOPengesahan", response);
          let dt = response.data.data;

          if (dt != null) {
            this.sioID = dt.idSio;
            // this.formValues.nama = dt.nama;
            // this.formValues.jabatan = dt.jabatan;
            this.formValues.kompetensi = dt.kompetensi;
            this.formValues.noSertifikat = dt.noRegistrasi;
            this.formValues.tempat = dt.tempat;
            this.formValues.tanggal =
              dt.tanggalTtd != null
                ? moment(dt.tanggalTtd).format("YYYY-MM-DD")
                : null;
            // if(dt.tandaTangan!=''&&dt.tandaTangan!=null){
            //   this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTangan;
            // }

            // this.formValues.namaTTD = dt.namaPengesah;
            // this.formValues.namaPemimpin = dt.namaPemimpin;
            // this.formValues.jabatanPemimpin = dt.jabatanPemimpin;

            this.$nextTick(function () {
              // DOM is now updated
              // `this` is bound to the current instance
              this.getKontraktor(dt.kontraktorId);
              this.getKelengkapan(this.sioID);
            });
          }
        })
        .catch((error) => {
          //this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getKontraktor(id) {
      axios
        .get(url_get_kontraktor + id, {
          headers: { accept: "application/json" },
        })
        .then((response) => {
          console.log(response);
          this.kontraktor = response.data.detailKontraktor;
          // set value form edit
          // this.url_icon = API_BASE_URL+CMS_VIEW_IMAGE+response.data.detailKontraktor.image;
          if (
            response.data.detailKontraktor.image != null ||
            response.data.detailKontraktor.image != ""
          ) {
            localStorage.setItem(
              "icon_kontraktor_cms",
              JSON.stringify({ icon: response.data.detailKontraktor.image })
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id == null ? "" : ret_kel.id;
          if (this.formValues.nama == null || this.formValues.nama == "") {
            this.formValues.nama =
              ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          }

          if (
            this.formValues.jabatan == null ||
            this.formValues.jabatan == ""
          ) {
            this.formValues.jabatan =
              ret_kel.jabatanPjo == null ? "" : ret_kel.jabatanPjo;
          }

          if (
            this.formValues.namaTTD == null ||
            this.formValues.namaTTD == ""
          ) {
            this.formValues.namaTTD =
              ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          }

          if (
            this.formValues.namaPemimpin == null ||
            this.formValues.namaPemimpin == ""
          ) {
            this.formValues.namaPemimpin =
              ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          }

          if (
            this.formValues.jabatanPemimpin == null ||
            this.formValues.jabatanPemimpin == ""
          ) {
            this.formValues.jabatanPemimpin =
              ret_kel.jabatanAtasan == null ? "" : ret_kel.jabatanAtasan;
          }
          if (this.fileTtd == null || this.fileTtd == "") {
            if (ret_kel.ttdAtasan != "" && ret_kel.ttdAtasan != null) {
              this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdAtasan;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.btn_eform {
  background-color: #fff;
  border: #d0d5dd;
}
</style>
